// src/utilities/conditional-render.ts
function conditionalRender(renderCondition, template) {
  return renderCondition ? template : "";
}

export {
  conditionalRender
};
